/** NAV_LINKS — id / label pairs used by NavBar and mobile menu. */
export const NAV_LINKS = [
  ['pipeline',  'Pipeline'],
  ['about',     'About'],
  ['skills',    'Skills'],
  ['timeline',  'Career'],
  ['education', 'Education'],
  ['projects',  'Projects'],
  ['contact',   'Contact'],
]

/** STAGES — CI/CD pipeline stage labels for the 3D visualisation. */
export const STAGES = ['Build', 'Unit Tests', 'API Tests', 'Regression', 'Security Scan', 'Deploy']

/** SKILL_COLS — two columns of skills with proficiency percentages. */
export const SKILL_COLS = [
  {
    title: 'Automation & Languages',
    items: [
      ['Selenium WebDriver',               92],
      ['Java (OOP)',                        88],
      ['Appium (Mobile)',                   80],
      ['Python',                            75],
      ['SQL',                               78],
    ],
  },
  {
    title: 'Testing & Tooling',
    items: [
      ['API Testing — REST Assured / Postman', 85],
      ['Performance Testing — JMeter',         82],
      ['Manual & Regression Testing',          90],
      ['CI/CD Pipelines',                      76],
      ['Git / GitHub',                         84],
    ],
  },
]

/** PROJECTS — real GitHub personal projects. */
export const PROJECTS = [
  {
    id:    0,
    icon:  '🛡️',
    name:  'GuardianShield',
    brief: 'VPN-based DNS filtering Android app, built in Kotlin.',
    tags:  ['Kotlin', 'Android', 'Networking'],
    detail: 'A VPN-based DNS filtering app implementing RFC 1035 packet parsing from scratch, PIN protection, and a 500+ domain bundled blocklist for on-device content blocking — no third-party DNS dependency.',
    back:  ['Kotlin', 'RFC 1035', 'VPNService', 'Android'],
  },
  {
    id:    1,
    icon:  '🚁',
    name:  'Drone Delivery Feasibility System',
    brief: 'Python modular system simulating drone delivery logistics.',
    tags:  ['Python', 'Simulation', 'Matplotlib'],
    detail: 'A modular Python system (reader.py, tasker.py, main.py) with regex-based input validation, battery-drain simulation, distance-matrix routing logic, and matplotlib visualisation of feasible delivery routes.',
    back:  ['Python', 'Regex', 'Matplotlib', 'Modular Design'],
  },
  {
    id:    2,
    icon:  '🦁',
    name:  'Megafauna Safari Simulation',
    brief: '19-class Java OOP simulation built to FIT9131 standards.',
    tags:  ['Java', 'OOP', 'UML'],
    detail: 'A full object-oriented safari ecosystem simulation spanning 19 classes, built to Monash FIT9131 coursework standards with complete JavaDoc documentation and UML class diagrams.',
    back:  ['Java', 'OOP Design', 'JavaDoc', 'UML'],
  },
]

/** CYCLE_LANGS — languages for the hero typing animation loop. */
export const CYCLE_LANGS = [
  { flag: '🇯🇵', label: '日本語', script: 'Japanese · Katakana', text: 'デヴァムクマール パテル', color: '#ef4444', type: 78, era: 42 },
  { flag: '🇨🇳', label: '普通话', script: 'Mandarin · Chinese',  text: '德瓦姆库马尔 帕特尔',  color: '#eab308', type: 84, era: 42 },
]
export const EN_LANG = { flag: '🇬🇧', label: 'English', script: '', color: '#00d4ff' }
export const L1 = 'Devamkumar'
export const L2 = 'Patel'

/** Ticker items for the infinite marquee. */
export const TICKER_ITEMS = [
  'Selenium WebDriver', 'Core Java', 'Appium', 'JMeter', 'REST Assured',
  'Postman', 'CI/CD Pipelines', 'Regression Testing', 'Page Object Model',
  'Git & GitHub Actions', 'PostgreSQL', 'Agile / Scrum',
]
